import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { MenuTypeCode } from '@/enums/enums';

import { useScrollContext } from '@/context/ScrollContext';
import { useLocation } from 'react-router';

// Design colors
const bgColor = '#001c40';
const activeColor = '#ffffff';
const inactiveTextColor = '#ffffff';
const activeTextColor = '#001c40';

export const FloatingSwitch = ({
  initialPosition,
  selectedType,
  onToggle,
}: {
  initialPosition: 'floating' | 'menu';
  selectedType: string;
  onToggle: (type: MenuTypeCode) => void;
}) => {
  const location = useLocation();
  const isInnerPage = location.pathname !== '/';

  const isParliament = selectedType === MenuTypeCode.Parliamentary;

  const { isScrolled } = useScrollContext();

  const theme = useTheme();
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));

  const effectivePosition = !lgDown ? initialPosition : 'menu';

  const isFloating = effectivePosition === 'floating';
  const isVisible = !isInnerPage && !lgDown ? (!isFloating ? isScrolled : !isScrolled) : true;

  return (
    <Box
      sx={{
        position: isFloating ? 'fixed' : 'relative',
        top: isFloating ? 150 : 'auto',
        left: isFloating ? { xs: 20, md: 46 } : 'auto',
        zIndex: 1000,
        backgroundColor: bgColor,
        borderRadius: '7px',
        padding: '4px',
        display: isVisible ? 'flex' : 'none',
        alignItems: 'center',
        width: isFloating ? '216px' : '170px',
        height: '40px',
        boxShadow: '0px 4px 4px -1px rgba(12,12,13,0.05)',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease', // for smooth transition
      }}
    >
      {/* Parliamentary Option */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          height: '29px',
          borderRadius: '7px',
          gap: '0.3rem',
          backgroundColor: isParliament ? activeColor : 'transparent',
        }}
        onClick={() => onToggle(MenuTypeCode.Parliamentary)}
      >
        {/* Red Dot for Parliamentary when selected */}
        {isParliament && (
          <Box
            sx={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              bgcolor: '#AE0000',
            }}
          />
        )}

        <Typography
          sx={{
            fontSize: '14px',
            color: isParliament ? activeTextColor : inactiveTextColor,
            fontWeight: 'normal',
          }}
        >
          نيابية
        </Typography>
      </Box>

      {/* Municipal Option */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          height: '100%',
          borderRadius: '7px',
          gap: '0.3rem',
          backgroundColor: !isParliament ? activeColor : 'transparent',
        }}
        onClick={() => onToggle(MenuTypeCode.Municipality)}
      >
        {/* Red Dot for Municipal when selected */}
        {!isParliament && (
          <Box
            sx={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              bgcolor: '#AE0000',
            }}
          />
        )}

        <Typography
          sx={{
            fontSize: '14px',
            color: !isParliament ? activeTextColor : inactiveTextColor,
            fontWeight: 'normal',
          }}
        >
          بلدية
        </Typography>
      </Box>
    </Box>
  );
};
